export enum GroupLicenseStatusEnum {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}
